<login-header></login-header>

<div class="team-heading">
  <div class="head-foot-width">
    <h1 class="heading3">The talented and dedicated team behind Family Central</h1>
  </div>
</div>

<!-- Advisory Board -->
<div class="team-section advisory-board">
  <div class="head-foot-width">
    <div class="team-section-heading">
      <h2 class="heading3">Advisory Board</h2>
      <p>We are privileged to count industry experts, leaders in venture capital, finance, law and customer relationships among our advisory board members, some of whom have been associated with Jason and Prem for two decades.</p>
    </div>
    <div class="team-members-wrapper">
      <p class="sofialight">Click on a team member to read a brief bio</p>

      <div class="team-members">

        @for (memb of AdvisoryBoardMembers; track memb; let i = $index) {
          <button type="button" class="team-btn" (click)="showTeamPopUp(TeamMembersData[i])">
            <span class="team-photo">
              <img src={{memb.image}} alt={{memb.name}}>
            </span>
            <h3 class="member-name heading4">
              {{memb.name}} <span>{{memb.info}}</span>
            </h3>
            <span class="member-designation">{{memb.description}}</span>
          </button>
        }
      </div>
    </div>
  </div>
</div>
<!-- Founding team members -->
<div class="team-section founding-team">
  <div class="head-foot-width">
    <div class="team-section-heading">
      <h2 class="heading3">Founding team members – and their families <span>(working remotely all across
      America)</span></h2>
    </div>

    <div class="team-members-wrapper">
      <p class="sofialight">Click on a team member to read a brief bio</p>

      <div class="team-members">
        @for (memb of FoundingTeamMembers; track memb; let i = $index) {
          <button type="button" class="team-btn" (click)="showTeamPopUp(TeamMembersData[i+3])">
            <span class="team-photo">
              <img src={{memb.image}} alt={{memb.name}}>
            </span>
            <h3 class="member-name heading4">
              {{memb.name}}<span>{{memb.info}}</span>
            </h3>
            <span class="member-designation">{{memb.description}}</span>
          </button>
        }
      </div>
    </div>
  </div>
</div>
<!-- Development team members -->
<div class="team-section development-team">
  <div class="head-foot-width">
    <div class="team-section-heading">
      <h2 class="heading3">Development team <span>(based in Hyderabad, India)</span></h2>
    </div>
    <div class="team-members-wrapper">
      <p class="sofialight">Click on a team member to read a brief bio</p>

      <div class="team-members">
        @for (memb of DevelopmentTeamMembers; track memb; let i = $index) {
          <button type="button" class="team-btn" (click)="showTeamPopUp(TeamMembersData[i+11])">
            <span class="team-photo">
              <img src={{memb.image}} alt={{memb.name}}>
            </span>
            <h3 class="member-name heading4">
              {{memb.name}}
            </h3>
            <span class="member-designation">{{memb.description}}</span>
          </button>
        }
      </div>
    </div>
  </div>
</div>

<app-footer (showPrice)="showPricing()"></app-footer>

<ng-template #pricing>
  <app-pricing (onCancel)="onClose()"></app-pricing>
</ng-template>

<ng-template #teampopup>
  <team-popup (onCancel)="onClose()" [teamMemeber]="currentTeamMember"></team-popup>
</ng-template>